import { Box, Button, Grid, Typography } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";
import animationData from "../components/Lottie/PermissionDenied.json";

const PermissionDenied = () => {
  const navigate = useNavigate();
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
          }}
        >
          <Box
            sx={{
              width: "300px",
              height: "300px",
              backgroundColor: "#fff",
            }}
          >
            <Lottie options={defaultOptions} />
          </Box>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          item
          xs={12}
          md={12}
        >
          <Typography
            maxWidth={600}
            width={"100%"}
            sx={{ fontSize: "18px", color: "gray" }}
            textAlign="center"
          >
            You do not have permission to view this page. Please contact
            administrator, If you believe this should not be the case!
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 3,
          }}
        >
          <Button onClick={() => navigate(-1)} size="medium" variant="outlined">
            Go Back
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default PermissionDenied;
